import React from 'react';
import get from 'lodash/get';
import cx from 'classnames';
import styles from './ProductPageSummary.css';
export default function ProductStockUrgency(props) {
    const { urgency, compact = false, containerClass } = props;
    const urgencyMessage = get(urgency, 'urgencyMessage');
    if (!urgencyMessage)
        return null;
    return (<div className={cx(styles['urgency-message'], containerClass, { [styles['compact']]: compact })}>
			{urgencyMessage}
		</div>);
}
